module.exports = __webpack_public_path__ + "static/media/seta.0b53235d.svg";